import React, { useState } from "react";

import {
  ArrowLeft,
  Gamepad2,
  ShoppingCart,
  Landmark,
  Printer,
  FileText,
  Plane,
  Globe2,
  BadgeDollarSign,
  ShieldCheck,
  ChevronRight,
  Eye,
} from "lucide-react";

import "../Styles/OtherServices.css";

import { useNavigate } from "react-router-dom";

const flyerList = [
  "/flyers/flyer1.png",
  "/flyers/flyer2.png",
  "/flyers/flyer3.png",
  "/flyers/flyer4.png",
  "/flyers/flyer5.png",
];

const services = [
  {
    icon: BadgeDollarSign,
    title: "Superbet Services",
    desc:
      "Online top-ups and cashout services for Superbet customers.",
  },

  {
    icon: ShoppingCart,
    title: "Online Shopping",
    desc:
      "Assistance with local and international online purchases.",
  },

  {
    icon: Gamepad2,
    title: "Gamers Recharge",
    desc:
      "PUBG, CODM, Free Fire and other gaming top-up services.",
  },

  {
    icon: Landmark,
    title: "Financial Services",
    desc:
      "Wire transfers, cheque exchange and damaged currency exchange.",
  },

  {
    icon: FileText,
    title: "Tax & Immigration",
    desc:
      "Tax services, passport forms and immigration assistance.",
  },

  {
    icon: Printer,
    title: "Printing Services",
    desc:
      "Photocopying, printing and stationery supplies.",
  },

  {
    icon: Globe2,
    title: "Visa Renewals",
    desc:
      "USA and Canada visa renewal application assistance.",
  },

  {
    icon: Plane,
    title: "Travel Bookings",
    desc:
      "Airline tickets and international hotel reservations.",
  },
];

const OtherServices = () => {

  const [selectedFlyer, setSelectedFlyer] =
    useState(null);

  const navigate = useNavigate();

  return (
    <div className="modern-other-page">

      {/* HERO */}
      <section className="modern-other-hero">

        <div className="modern-other-overlay" />

        <div className="modern-other-content">

          <button
            className="modern-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-other-badge">
            OTHER SERVICES
          </div>

          <h1 className="modern-other-heading">
            More Than Just
            <span> Financial Services.</span>
          </h1>

          <p className="modern-other-text">
            RCS continues to expand its
            services to provide convenience,
            accessibility and support for
            customers across Guyana.
          </p>

        </div>

      </section>

      {/* SERVICES */}
      <section className="modern-other-services">

        <div className="modern-other-grid">

          {services.map((service, index) => {

            const Icon =
              service.icon;

            return (

              <div
                className="modern-other-card"
                key={index}
              >

                <div className="modern-other-icon">
                  <Icon size={32} />
                </div>

                <h3>
                  {service.title}
                </h3>

                <p>
                  {service.desc}
                </p>

                <div className="modern-other-arrow">
                  <ChevronRight size={20} />
                </div>

              </div>
            );
          })}

        </div>

      </section>

      {/* FLYERS */}
      <section className="modern-flyers-section">

        <div className="modern-flyers-header">

          <div className="modern-flyers-badge">
            SERVICE FLYERS
          </div>

          <h2>
            Explore Our Promotional Flyers
          </h2>

        </div>

        <div className="modern-flyer-grid">

          {flyerList.map(
            (flyer, index) => (

            <div
              className="modern-flyer-card"
              key={index}
              onClick={() =>
                setSelectedFlyer(flyer)
              }
            >

              <img
                src={flyer}
                alt={`Flyer ${index + 1}`}
                className="modern-flyer-img"
              />

              <div className="modern-flyer-overlay-card">

                <Eye size={22} />

                View Flyer

              </div>

            </div>
          ))}

        </div>

      </section>

      {/* MODAL */}
      {selectedFlyer && (

        <div
          className="modern-flyer-modal"
          onClick={() =>
            setSelectedFlyer(null)
          }
        >

          <div
            className="modern-flyer-modal-content"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            <img
              src={selectedFlyer}
              alt="Flyer"
            />

            <button
              className="modern-flyer-close"
              onClick={() =>
                setSelectedFlyer(null)
              }
            >
              ✕
            </button>

          </div>

        </div>
      )}

    </div>
  );
};

export default OtherServices;